import { Component } from '@angular/core';

@Component({
  selector: 'app-socialmedia',
  imports: [],
  templateUrl: './socialmedia.component.html',
  styleUrl: './socialmedia.component.scss'
})
export class SocialmediaComponent {

}
